import { ThemePackage } from './types'

export const defaultTheme: ThemePackage = {
    componentVariables: {
        pageBackground: undefined,
    },
}
